import { Score, TreatmentType } from "@keita/lanepatrol-sdk";
import { LabelDetection } from "./LabelDetection";
import { ScoreImpact } from "../../coding/models/ScoreImpact";

export interface LocationCoordinates {
  latitude: number;
  longitude: number;
  altitude: number | null;
}

export interface UpdateOsaNodeLocation {
  osaNodeId: string;
  latitude: number;
  longitude: number;
}

export interface OsaNode extends LocationCoordinates {
  id: string;
  osaWayId: string;
  name: string;
  index: number;
  distanceFromStart: number;
  distanceToNext: number;
  slope: number;
  dateTime: string;
  photoStatus: NodePhotoStatus;
  photo: {
    fileName: string;
    url: string | any;
    source: PhotoSource;
    panoramic: boolean;
  } 
  | null;
  score: Score | null;
  labels: LabelDetection[] | null;
  treatments: Treatment[] | null;
  scoreImpact: ScoreImpact | null;
}

export interface Treatment {
  type: TreatmentType;
  score: Score;
}

export interface CreateOsaNode extends LocationCoordinates {
  osaWayId: string;
  name: string;
  index: number;
  dateTime: string;
  photo: {
    image: string;
    source: PhotoSource;
  } | null;
}

export enum PhotoSource {
  Hardware = "Hardware",
  Screen = "Screen",
}

export enum OsaWayUploadProcessStatus {
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
  DONE = "DONE",
}

export interface OsaWayUploadStatus {
  status?: OsaWayUploadProcessStatus;
  progress?: number;
}

export enum NodePhotoStatus {
  Raw = "Raw",
  Ready = "Ready",
  Failed = "Failed",
}
